import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { MEMBERS_LAYOUT_STORAGE_KEY, MEMBERS_LAYOUT_TABLE } from '../../hooks/useMembersLayoutMode';

/** Legacy route: imposta layout tabella e reindirizza a /gym/members */
export default function MembersDraftRedirect() {
    const location = useLocation();

    useEffect(() => {
        try {
            localStorage.setItem(MEMBERS_LAYOUT_STORAGE_KEY, MEMBERS_LAYOUT_TABLE);
        } catch {
            /* ignore */
        }
    }, []);

    const search = location.search || '';
    return <Navigate to={`/gym/members${search}`} replace />;
}
